export const badges = [
  'ADMIN',
  'ADMIN_WEB',
  'ANALYTICS',
  'APP_FOR_TITLE',
  'CALL_CENTER_AGENT',
  'CAN_DISABLE_USERS',
  'CARFAX_FRAUD_REVIEW',
  'CONTACT_LIENHOLDER',
  'CONTINUE_AS_CUSTOMER',
  'CREATE_ZENDESK_TICKET',
  'CURRENT_MORTGAGE_STATEMENT',
  'DRIVER_LICENSE',
  'EDIT_USER',
  'FINAL_LOAN',
  'FRAUD',
  'FUNDING',
  'HANDLE_INSUFFICIENT_FUNDS',
  'HANDLE_TITLE',
  'IMAGE',
  'INSURANCE_POLICY',
  'LISTINGS',
  'LOSS_PAYEE',
  'MESSAGING',
  'POSTING',
  'PROMOTIONS',
  'PROOF_OF_EMPLOYMENT',
  'PROOF_OF_INSURANCE',
  'PROOF_OF_RESIDENCE',
  'RECEIVE_APP_FOR_TITLE',
  'RECEIVE_LPOA',
  'RECEIVE_SPOA',
  'REFIS',
  'REFI_PHONE',
  'REFUND_DOWN_PAYMENT',
  'REGISTRATION',
  'REVIEW_BACKGROUND_ERROR',
  'REVIEW_FOR_FRAUD',
  'REVIEW_OFAC',
  'REVIEW_PLAID_DATA_MISMATCH',
  'REVIEW_STATEMENT',
  'REVIEW_USER_DATA_MISMATCH',
  'SEND_BUYER_PACKET',
  'SEND_FUNDS_TO_LIENHOLDER',
  'SEND_SPOA_TO_SELLER',
  'SIGN_LOAN_AGREEMENT',
  'SSN_CARD',
  'SUBMIT_PROOF_OF_INCOME',
  'SUPERUSER',
  'SUPPORT',
  'SUSPEND_USER',
  'TASKS',
  'TEXT',
  'TITLE',
  'TRADEINS',
  'TRANSACTIONS',
  'UNDERWRITING',
  'UPDATE_LIENHOLDER_INFO',
  'UPLOAD_DOCS',
  'USERS',
  'VEHICLES',
  'VERIFY_FUNDS',
  'VERIFY_MILEAGE',
  'VIEW_DOCS',
]
